import { Chip, ChipProps } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { useMemo, Fragment, ReactNode } from 'react';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { NBSP } from '~/common/constants';
import { TooltipTypography } from '~/components/TooltipTypography/TooltipTypography';

export type ChipCellValue = Union.Nullable<ReactNode>;

interface ChipCellProps<R extends GridValidRowModel = any> {
  value: ChipCellValue | ChipCellValue[];
  row: R;
  size?: ChipProps['size'];
}

export const ChipCell = <R extends GridValidRowModel = any>({ value: valueProp, size }: ChipCellProps<R>) => {
  const values: Union.Nullable<ChipCellValue[]> = useMemo(() => {
    if (valueProp) {
      return Array.isArray(valueProp) ? valueProp : [valueProp];
    }
    return null;
  }, [valueProp]);

  if (values) {
    const result = values
      .map((value, index) =>
        value ? (
          <Fragment key={index}>
            {index > 0 ? NBSP : null}
            <TooltipTypography key={index} title={value}>
              <Chip label={value} size={size} />
            </TooltipTypography>
          </Fragment>
        ) : null,
      )
      .filter(Boolean);

    return result.length ? <>{result}</> : null;
  }
  return <>{NULLISH_CELL_VALUE}</>;
};
